export default __webpack_public_path__ + "static/media/pixellab--og--contact.5c0bf673.jpg";